/**
 * DeleteFileModal — the Adviser-only delete confirmation for a client file
 * (CLAUDE.md §33.5 for the test-file wording), decomposition step F6c
 * (§8.4). handleDeleteFile stays in FileDetail.jsx — it is the write path
 * and navigates on success — and is passed in with the setter, so the body
 * is verbatim and keeps its original indentation. The view's
 * `showDeleteConfirm` guard stays at the call site.
 */

import { motion } from 'framer-motion';
import { styles as caseModalStyles } from './caseScreenshots/EditCasesModal';

export default function DeleteFileModal({ file, deleting, setShowDeleteConfirm, handleDeleteFile }) {
  return (
        <div style={styles.modalOverlay} onClick={() => !deleting && setShowDeleteConfirm(false)}>
          <motion.div
            className="card"
            style={styles.modal}
            onClick={(e) => e.stopPropagation()}
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
          >
            <h3 style={{ marginBottom: '0.75rem', color: 'var(--cp-danger)' }}>
              {file.isTest ? 'Delete Test File' : 'Delete File'}
            </h3>
            <p style={{ color: 'var(--cp-text-muted)', fontSize: '0.85rem', marginBottom: '0.5rem' }}>
              {file.isTest
                ? 'Are you sure you want to permanently delete this test file?'
                : 'Are you sure you want to permanently delete this file?'}
            </p>
            <p style={{ fontWeight: 600, fontSize: '0.9rem', marginBottom: '0.75rem', color: 'var(--cp-text)' }}>
              {file.clientName}
            </p>
            <p style={{ color: 'var(--cp-danger)', fontSize: '0.8rem', marginBottom: '1rem' }}>
              This action cannot be undone. The file record and all associated voice notes, attachments, and screenshots will be permanently removed.
            </p>
            <div style={{ display: 'flex', gap: '0.5rem' }}>
              <button
                className="btn btn-outline"
                onClick={() => setShowDeleteConfirm(false)}
                disabled={deleting}
              >
                Cancel
              </button>
              <button
                style={styles.confirmDeleteBtn}
                onClick={handleDeleteFile}
                disabled={deleting}
              >
                {deleting ? 'Deleting…' : 'Delete Permanently'}
              </button>
            </div>
          </motion.div>
        </div>
  );
}

// Shared modal chrome, owned by EditCasesModal (§8.4).
const styles = {
  modalOverlay: caseModalStyles.modalOverlay,
  modal: caseModalStyles.modal,
  confirmDeleteBtn: caseModalStyles.confirmDeleteBtn,
};
